import Vue from 'vue'
import Vuex from 'vuex';
import {getFactoryList} from "../api/api";
// import {types} from "node-sass";
// import '../until/axios';

//1、注册
Vue.use(Vuex)

//2、创建
const store = new Vuex.Store({
  state: {
    user: {},
    companyInfo: {},
    allClassification: [],
    submitting: false, // 是否正在提交
    submitText: 'common.submitting',
    areasInfo: null, // 地址列表信息
    manufacturer: [], // 生产厂家
    stopType: [{ // 店铺类型
      id: 'offline',
      label: '线下',
    },
      {
        id: 'online',
        label: '线上',
      }
    ],
    uploadImgType: ['png', 'jpg', 'jpeg'], // 上传图片类型
    uploadImgMaxSize: 2,
    selectInput: false, // 文本框输入弹框
    roleTypes: [
      { label: 'security.consumer', val: 'BUYER' },
      { label: 'security.distributor', val: 'SELLER' },
    ],
    expressCompanies: [],
    storeExceptions: [
      'NO_EXCEPTION', 'PART_SENT', 'DELIVERY_STOP', 'NO_INVENTORY',
    ],
    yesOrNo: [
      { label: 'common.yes', val: true },
      { label: 'common.no', val: false },
    ],
    pushStateKey: {
      CANCEL: 2, // 取消
      REJECTED: 5, // 驳回
    },
    pushStateList: [
      { key: 0, label: 'pushState.noPush' },
      { key: 1, label: 'pushState.normal' },
      { key: 2, label: 'pushState.cancel' },
      { key: 3, label: 'pushState.accept' },
      { key: 4, label: 'pushState.finish' },
      { key: 5, label: 'pushState.reject' },
    ],
    id_token: 'sup_id_token',
    postageAddress: [],

  },
  getters: {

  },
  mutations: {
    USER_INFO(state, data) {
      sessionStorage.setItem('user', JSON.stringify(data.data.user))
      sessionStorage.setItem(state.id_token, data.data.token)
      state.user = data.data.user;
    },
    INIT_COMPANY_INFO(state, data) {
      state.companyInfo = data;
    },
    GET_USER_INFO(state, user) {
      state.user = JSON.parse(user);
    },
    INIT_CLASSIFICATION(state, data) {
      state.allClassification = data;
    },
    CHANGE_SUBMIT_STATE(state, data) {
      state.submitting = data;
    },
    CHANGE_SUBMIT_TEXT(state, data) {
      state.submitting = data.flag || false;
      state.submitText = data.val || 'common.submitting'
    },
    INIT_ADDRESS(state, data) {
      state.areasInfo = data;
    },
    INIT_STATE(state, data) {
      state[data.key] = data.val;
    },
    SWITCH_INPUT(state, flag) {
      state.selectInput = flag || false;
    },
    INIT_POSTAGE_ADDRESS(state, data) {
      state.postageAddress = data;
    },
  },

  actions: {
    // 公司配置信息
    getCompanyInfo({ commit }, params = {}) {
      return Vue.$http.post('company/detail', params).then((res) => {
        const { status, data } = res;
        if (status === 200) {
          commit('INIT_COMPANY_INFO', data.data);
        }
      })
    },
    // 所有分类
    getAllClassification({ commit }, params = {}) {
      return Vue.$http.post('productCategory/list', params).then((res) => {
        const { status, data } = res;
        if (status === 200) {
          commit('INIT_CLASSIFICATION', data.data.rows);
        }
      })
    },
    // 获取所有厂家
    getFactoryList({ commit }, params = {}) {
      return Vue.$http.get('produceFactory/list', params).then((res) => {
        const { status, data } = res;
        if (status === 200) {
          commit('INIT_STATE', { key: 'manufacturer', val: data.data});
        }
      })
    },
    // 获取快递公司列表
    getExpressCompanies({ commit }, params = {}) {
      return Vue.$http.post('expressCompany/list', params).then((res) => {
        const { status, data } = res;
        if (status === 200) {
          commit('INIT_STATE', { key: 'expressCompanies', val: data.data.rows});
        }
      })
    }
  },
})

//3、导出
export default store




// WEBPACK FOOTER //
// ./src/store/index.js